import React, { useEffect, useState } from "react";
import { Table, Typography, message } from "antd";
import { useParams } from "react-router-dom";

const { Title } = Typography;

function ManageSprints() {

  const { projectId } = useParams();
  const [sprints, setSprints] = useState([]);

  useEffect(() => {

    const fetchSprints = async () => {

      try {

        const token = localStorage.getItem("access-token");

        const res = await fetch(
          `https://rhrmapi.up2dateinc.com/api/sprints/project/${projectId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        const data = await res.json();

        if (Array.isArray(data)) {
          setSprints(data);
        } else {
          setSprints([]);
        }

      } catch (error) {

        message.error("Failed to load sprints");

      }

    };

    fetchSprints();

  }, [projectId]);

  const columns = [
    {
      title: "SL No",
      render: (_, __, index) => index + 1
    },
    {
      title: "Sprint Name",
      dataIndex: "sprintName"
    },
    {
      title: "Duration",
      dataIndex: "duration"
    },
    {
      title: "Start Date",
      dataIndex: "startDate"
    },
    {
      title: "Sprint Goal",
      dataIndex: "sprintGoal"
    },
    {
      title: "Status",
      dataIndex: "status"
    }
  ];

  return (
    <div>

      <Title level={3}>Manage Sprints</Title>

      <Table
        columns={columns}
        dataSource={Array.isArray(sprints) ? sprints : []}
        rowKey="_id"
        pagination={{ pageSize: 5 }}
      />

    </div>
  );
}

export default ManageSprints;